import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoCustomTable,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoSectionContainer,
    RaikoTableTitleContainer,
    showServerErrorMessage,
    RaikoSimpleInputOutlined,
    RaikoNumberInputOutlined,
    RaikoCustomSimpleChip,
    RaikoChipTypes, showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import React, {useEffect, useState} from "react";
import {FeedBackService} from "../../serverService/feedbackService/FeedBackService";
import {useAuthState} from "../../context/AuthContext";
import {convertUniversalDateToPersianDate} from "../../util/DateConvertor";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {useDebounce} from "@uidotdev/usehooks";
import {useNavigate} from "react-router-dom";

export default function Feedback() {

    const size = 20
    const {fundID} = useAuthState()

    const [page, setPage] = useState(0);
    const [numberOfItems, setNumberOfItems] = useState("");
    const [fullName, setFullName] = useState("");
    const [nationalCode, setNationalCode] = useState("");
    const [groupName, setGroupName] = useState("");
    const [feedbackData, setFeedbackData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);

    const [pageCount, setPageCount] = useState(0);

    const fullNameFilter = useDebounce(fullName, 500);
    const nationalCodeFilter = useDebounce(nationalCode, 500);
    const groupNameFilter = useDebounce(groupName, 500);

    const service = new FeedBackService()

    useEffect(() => {
            if (typeof service !== 'undefined') {
                getFeedBackListFromServer()
            }
        },
        [
            fullNameFilter,
            nationalCodeFilter,
            groupNameFilter,
            fundID
        ]
    )


    function tablePreparation(id, number, title, description, sendAt, status, senderFirstName, senderLastName, senderPhoneNumber, senderGroupName) {
        return {
            id: id,
            number: number,
            title: title,
            name: `${senderFirstName} ${senderLastName}`,
            cash_group: senderGroupName,
            phoneNumber: senderPhoneNumber ? senderPhoneNumber : "-",
            date: convertUniversalDateToPersianDate(sendAt),
            description: description,
            state: status === "REVIEWED" ? <RaikoCustomSimpleChip title={"بررسی شده"} type={RaikoChipTypes.success}/>
                : <RaikoCustomSimpleChip title={"در انتظار بررسی"} type={RaikoChipTypes.warning}/>,
        }
    }

    function getFeedBackListFromServer() {
        setTableLoading(true)
        setFeedbackData([])
        service.getFeedBackList(
            fundID,
            page,
            size,
            fullNameFilter,
            groupNameFilter,
            nationalCodeFilter
        ).then(
            response => {
                setNumberOfItems(response.numberOfItems)
                setPageCount(response.totalPage)
                response.data.map((item, index) => {
                    setFeedbackData(prevState => [
                        ...prevState,
                        tablePreparation(
                            item.id,
                            (page * 20) + index + 1,
                            item.title,
                            item.description,
                            item.sendAt,
                            item.status,
                            item.senderFirstName,
                            item.senderLastName,
                            item.senderPhoneNumber,
                            item.senderGroupName,
                        )
                    ])
                })
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    const navigate = useNavigate()

    function showFeedbackInfo(feedbackId) {
        navigate(RouteHelper.FeetBackInfo.globalUrl.replace(":id", feedbackId))
    }

    function changePage(newPage) {
        setPage(newPage);
        getFeedBackListFromServer()
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.FeedBack.name}</title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.FeedBack.name,
                            ""
                        )
                    ]}/>
                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer
                            title={"جستجو"}
                            subTitle={"برای جستجو عبارت مورد نظر خود را وارد نمایید."}
                        >
                            <RaikoGridThreeColumn>
                                <RaikoSimpleInputOutlined
                                    labelText={"نام و نام خانوادگی"}
                                    setValue={setFullName}
                                    value={fullName}/>
                                <RaikoSimpleInputOutlined
                                    labelText={"نام گروه"}
                                    setValue={setGroupName}
                                    value={groupName}/>
                                <RaikoNumberInputOutlined
                                    labelText={"کد ملی"}
                                    setValue={setNationalCode}
                                    value={nationalCode}/>
                            </RaikoGridThreeColumn>

                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={"بازخورد"}
                                amount={numberOfItems}
                            />
                            <RaikoCustomTable
                                header={columns}
                                data={feedbackData}
                                isLoading={tableLoading}
                                pageCount={pageCount}
                                rowClicked={showFeedbackInfo}
                                handlePaginationChange={changePage}
                            />
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>

                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}
const columns = [
    {
        id: 'number',
        label: '#',
        align: 'right',

    },
    {
        id: 'title',
        label: 'عنوان',
        align: 'right',
    },
    {
        id: 'name',
        label: 'نام و نام خانوادگی',
        align: 'right',
    },
    {
        id: 'phoneNumber',
        label: 'شماره همراه',
        align: 'right',
    },
    {
        id: 'cash_group',
        label: 'گروه',
        align: 'right',
    }
    ,
    {
        id: 'date',
        label: 'تاریخ',
        align: 'right',
    }
    ,
    {
        id: 'description',
        label: 'توضیحات',
        align: 'right',
    }
    ,
    {
        id: 'state',
        label: 'وضعیت',
        align: 'right',
    },];